import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { withRouter } from 'react-router-dom';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import { withStyles } from 'material-ui/styles';
import Input, { InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import * as actions from '../costEstimate.actions';
import { getCostEstimateForType } from '../costEstimate.selectors';
import { getCurrentUserRole } from '../../user/user.selectors';

import { UserRoles } from '../../user/user.constants';
const styles = theme => ({
  root: {
    borderCollapse: 'separate',
    tableLayout: 'fixed',
    padding: '16px',
  },
  head: {
    color: theme.palette.text.hint,
    background: 'rgba(175, 175, 175, 0.1)',
    height: 60,
  },
  headRow: {
    height: 'inherit',
  },
  headCell: {
    height: 'inherit',
    verticalAlign: 'middle',
  },
  cellLabel: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});
const rows = [
  { label: 'Pyyntihinta (alv 0%)', name: 'offeredPrice', adornment: '€' },
  { label: 'Tavoitehinta (alv 0%)', name: 'goalPrice', adornment: '€' },
  { label: 'Kate %', name: 'marginPercent', adornment: '%' },
  { label: 'Kate € (alv 0%)', name: 'marginCurrency', adornment: '€' },
  {
    label: 'Koneen arvoa nostava työlaite (alv 0%)',
    name: 'missingEquipment',
    adornment: '€',
  },
  {
    label: 'Korjausarvio (työ ja osat) (alv 0%)',
    name: 'repairEstimate',
    adornment: '€',
  },
  { label: 'Kuljetus ja varastointi (alv 0%)', name: 'logistics', adornment: '€' },
  {
    label: 'Vaihtoesineen nettohyvitys (alv 0%)',
    name: 'netCredit',
    adornment: '€',
  },
  {
    label: 'Kommentit', name: 'comment', adornment: '', type: 'text'
  }
];
class CostEstimateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellerEstimate: {
        _id: undefined,
        inspection: props.id,
        type: 'seller', //either seller or department
        offeredPrice: null,
        goalPrice: null,
        marginPercent: null,
        marginCurrency: null,
        missingEquipment: null,
        repairEstimate: null,
        logistics: null,
        netCredit: null,
        remarks: '',
        comment: ''
      },
      departmentEstimate: {
        _id: undefined,
        inspection: props.id,
        type: 'department', //either seller or department
        offeredPrice: null,
        goalPrice: null,
        marginPercent: null,
        marginCurrency: null,
        missingEquipment: null,
        repairEstimate: null,
        logistics: null,
        netCredit: null,
        remarks: '',
        comment: ''
      },
      errors: [],
    };
  }
  componentDidMount = () => {
    const { readCostEstimates, id, onRef } = this.props;
    onRef(this);
    readCostEstimates(id);
  };

  componentWillUnmount = () => {
    const { onRef } = this.props;
    onRef(undefined);
  };
  submit = (estimateType, returnAction) => {
    if (!estimateType) return;
    const { updateCostEstimate, id } = this.props;
    const updatedEstimate = {
      ...this.state[estimateType],
      status: 'completed',
    };
    this.resolveEstimateDerivativeValues(updatedEstimate);
    updatedEstimate._id = id; //NOTE: update the real id to state estimate
    updateCostEstimate(updatedEstimate).then(returnAction);
  };
  throttledUpdate = debounce(
    formData => {
      const { updateCostEstimate, id } = this.props;
      formData._id = id; //NOTE: update the real id to state estimate
      updateCostEstimate(formData);
      //console.log('saving', formData);
    },
    500,
    { leading: false }
  );

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.sellerCostEstimate._id && !this.state.sellerEstimate._id) {
      this.setState({
        sellerEstimate: nextProps.sellerCostEstimate,
      });
    }
    if (
      nextProps.departmentCostEstimate &&
      nextProps.departmentCostEstimate._id &&
      !this.state.departmentEstimate._id
    ) {
      this.setState({ departmentEstimate: nextProps.departmentCostEstimate });
    }
  }

  getValue(estimate, key) {
    const value = estimate[key];

    if (value || value === 0 || value === '0') {
      return value.toString();
    }
    return '';
  }

  /**
   * Resolves the values that are derived from user input into 
   * the given estimate object
   * 
   * @param {*} estimate 
   */
  resolveEstimateDerivativeValues(estimate) {
    estimate['marginCurrency'] = Math.round(estimate['goalPrice'] * estimate['marginPercent'] / 100.0);
    estimate['netCredit'] = Math.round(
      estimate['goalPrice'] -
        estimate['marginCurrency'] +
        estimate['missingEquipment'] -
        estimate['repairEstimate'] -
        estimate['logistics']
    );
  }

  onChangeNumber = (event, estimateType) => {
    const key = event.target.name;
    const value = event.target.value;
    this.setEstimateField(estimateType, key, Number(value));
  };

  onChangeText = (event, estimateType) => {
    const key = event.target.name;
    const value = event.target.value;
    this.setEstimateField(estimateType, key, value);
  };

  setEstimateField(estimateType, key, value) {
    const estimate = {
      ...this.state[estimateType],
      [key]: value,
    };
    this.resolveEstimateDerivativeValues(estimate);
    this.setState({
      [estimateType]: estimate,
    });
    this.throttledUpdate(estimate);

  }

  renderEstimateField(row, estimateType) {
    const estimate = this.state[estimateType];
    if (estimate) {
      const readOnly = estimate.status === 'completed' || row.name === 'marginCurrency' || row.name === 'netCredit';

      let input;
      if (row.type === 'text') {
        input = (<Input
          name={row.name}
          type='text'
          disabled={readOnly}
          onChange={event => this.onChangeText(event, estimateType)}
          value={this.getValue(estimate, row.name)}
          endAdornment={<InputAdornment position="end">{row.adornment}</InputAdornment>}
          multiline={row.type==='text'}
        />);
      } else {
        input = (<Input
          name={row.name}
          type='number'
          disabled={readOnly}
          onChange={event => this.onChangeNumber(event, estimateType)}
          value={this.getValue(estimate, row.name)}
          endAdornment={<InputAdornment position="end">{row.adornment}</InputAdornment>}
        />);
      }
      return (<TableCell>{ input }</TableCell>);
    }
  }

  render() {
    const { classes, isDepartment } = this.props;
    let columns = [''];
    const { sellerEstimate, departmentEstimate } = this.state;
    const hasSellerEstimate = sellerEstimate && sellerEstimate._id;
    if (hasSellerEstimate) columns.push('Myyjän arvio');
    const hasDepartmentEstimate =
      isDepartment &&
      departmentEstimate &&
      departmentEstimate._id &&
      (!hasSellerEstimate || sellerEstimate.status === 'completed');
    if (hasDepartmentEstimate) {
      columns.push('Osaston arvio');
    } else {
      columns.push('Odottaa osaston arviota');
    }

    return (
      <div>
        <Table className={classes.root}>
          {columns.length > 0 && (
            <TableHead className={classes.head}>
              <TableRow className={classes.headRow}>
                {columns.map((prop, index) => {
                  return (
                    <TableCell key={index} className={classes.headCell}>
                      <div className={classes.cellLabel}>{prop}</div>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {rows.map((row, i) => {
              return (
                <TableRow key={i}>
                  <TableCell className={classes.labelCell}>
                    <FormControl className={classes.cellLabel}>{row.label}</FormControl>
                  </TableCell>
                  {sellerEstimate._id && this.renderEstimateField(row, 'sellerEstimate')}
                  {hasDepartmentEstimate && this.renderEstimateField(row, 'departmentEstimate')}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state, { match, backPath }) => {
  const { params: { id } } = match;
  backPath = '/';
  const role = getCurrentUserRole(state);
  const isDepartment = role && (role === UserRoles.DEPARTMENT || role === UserRoles.SUPERUSER);
  const sellerCostEstimate = getCostEstimateForType(state, 'seller', id);
  const departmentCostEstimate = isDepartment ? getCostEstimateForType(state, 'department', id) : null;
  return {
    id,

    sellerCostEstimate,
    departmentCostEstimate,
    isDepartment,
  };
};

export default withRouter(connect(mapStateToProps, Object.assign({}, actions))(withStyles(styles)(CostEstimateForm)));



// WEBPACK FOOTER //
// ./src/modules/costEstimate/components/CostEstimateForm.js